<template>
  <div class="Kefu_I">
    <div class="headNavs">
      <div class="headTilte">专属客服</div>
      <div class="headDetails">平台会员用户专属客服电话</div>
    </div>

    <div class="capitalNav">
      <div style="display:flex;justify-content: space-between;">
        <div class="NavLi">
          <div class="NavLiName">类型：</div>
          <div class="NavLiIpt">
            <el-select v-model="search.type" placeholder="全部">
              <el-option v-for="(item,key) in TypeList" :key="key" :label="item" :value="key"></el-option>
            </el-select>
          </div>
        </div>
        <div class="NavLi">
          <div class="NavLiName">姓名：</div>
          <div class="NavLiIpt">
            <el-input v-model="search.username" placeholder="请填写姓名"></el-input>
          </div>
        </div>
        <div class="NavLi">
          <div class="NavLiName">电话：</div>
          <div class="NavLiIpt">
            <el-input v-model="search.phone" placeholder="请填写电话"></el-input>
          </div>
        </div>
        <div class="NavLi">
          <div class="NavLiName">服务：</div>
          <div class="NavLiIpt">
            <el-input v-model="search.service" placeholder="请填写服务"></el-input>
          </div>
        </div>
        <div class="NavLi" v-for="obj in 4" :key="obj"></div>
      </div>
      <div style="margin-top:20px">
        <div class="NavLi">
          <div class="NavLiName">状态：</div>
          <div class="NavLiIpt">
            <el-select v-model="search.status" placeholder="全部">
              <el-option v-for="(item,key) in StatusList" :key="key" :label="item" :value="key"></el-option>
            </el-select>
          </div>
          <div class="NavLiQuery" style="margin-left: 24px;" @click="BtnSearch()">查询</div>
          <div class="NavLiReset" @click="BtnSearch(false)">重置</div>
        </div>
      </div>
    </div>

    <div class="TablesList">
      <div class="TablesADD">
        <div class="NavLiReset" @click="BtnSearch(false)"><i class="el-icon-refresh"></i>刷新</div>
        <div class="NavLiQuery" @click="showAdd()"><i class="el-icon-plus"></i>创建</div>
        <div class="NavLiDelte" @click="DelMore()"><i class="el-icon-delete"></i>批量删除</div>
        <div class="TableIpt"> 
          <input @keyup.enter.native="BtnSearch()" type="text" v-model="search.keyword" placeholder="请输入姓名">
          <div class="seso" @click="BtnSearch()"><i class="el-icon-search"></i></div>
        </div>
      </div>
      <el-table
        :data="tableData"
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        @selection-change="handleSelect">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="kefu_id" label="ID" width="55" align="left"></el-table-column>
        <el-table-column prop="type_text" label="类型"></el-table-column>
        <el-table-column prop="username" label="姓名"></el-table-column>
        <el-table-column label="头像">
          <template #default="scope">
            <el-image class="Toper"
                      :src="scope.row.full_avatar" alt=""
                      :preview-src-list="[scope.row.full_avatar]"
                      :initial-index="0"
                      :hide-on-click-modal = true
                      fit="cover">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机"></el-table-column>
        <el-table-column prop="service" label="服务"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="scope">
            <span>{{ {0:'隐藏',1:'显示'}[scope.row.status||0] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="weigh" label="权重"></el-table-column>
        <el-table-column prop="createtime" label="创建时间"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="scope">
            <div class="el_butto" >
              <el-button
                  type="text"
                  @click="HandleEdit(scope.$index,scope.row)"
              >编辑
              </el-button>
            </div>
            <div class="el_butto rere" >
              <el-button
                  type="text"
                  class="red"
                  @click="HandleDel(scope.$index, scope.row)"
              >删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="page.currentPage"
            :page-size="page.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </div>


    <div class="show" v-if="addPanel || editPanel">
      <div class="rightPanel-background"/>
      <div class="EditNew">
        <div class="EditNewTop">
          <div>{{titleMath}}</div>
          <div @click="Close()"><i class="el-icon-close"></i></div>
        </div>
        <el-form class="EditNewForm" :model="Row" :rules="rules" ref="ruleFormRef">
          <el-form-item class="EditNewFormItem" prop="type">
            <div class="EditNewFormItemName"><span class="signSpan">* </span>类型</div>
            <div class="EditNewFormItemIpt">
              <el-select v-model="Row.type" placeholder="请选择类型">
                <el-option v-for="(item,key) in TypeList" :key="key" :label="item" :value="key"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item class="EditNewFormItem" prop="username">
            <div class="EditNewFormItemName"><span class="signSpan">* </span>姓名</div>
            <div class="EditNewFormItemIpt">
              <el-input v-model="Row.username" placeholder="请填写客服姓名" class="El_ii"></el-input>
            </div>
          </el-form-item>
          <el-form-item class="EditNewFormItem" prop="phone">
            <div class="EditNewFormItemName"><span class="signSpan">* </span>电话</div>
            <div class="EditNewFormItemIpt">
              <el-input type="number" v-model="Row.phone" placeholder="请输入客户电话" class="El_ii"></el-input>
            </div>
          </el-form-item>
          <el-form-item class="EditNewFormItem" prop="service">
            <div class="EditNewFormItemName"><span class="signSpan">* </span>接待服务</div>
            <div class="EditNewFormItemIpt">
              <el-input v-model="Row.service" placeholder="请输入接待服务" class="El_ii"></el-input>
            </div>
          </el-form-item>
          <el-form-item class="EditNewFormItem" prop="weixin">
            <div class="EditNewFormItemName"><span class="signSpan">* </span>微信</div>
            <div class="EditNewFormItemIpt">
              <el-input v-model="Row.weixin" placeholder="请填写微信" class="El_ii"></el-input>
            </div>
          </el-form-item>
          <el-form-item class="EditNewFormItem" prop="tag">
            <div class="EditNewFormItemName"><span class="signSpan">* </span>标签</div>
            <div class="EditNewFormItemIpt">
              <el-input v-model="Row.tag" placeholder="请输入标签" class="El_ii"></el-input>
            </div>
          </el-form-item>
          <el-form-item class="EditNewFormItem" prop="weigh">
            <div class="EditNewFormItemName"><span class="signSpan">* </span>权重</div>
            <div class="EditNewFormItemIpt">
              <el-input type="number" v-model="Row.weigh" placeholder="请填写权重" class="El_ii"></el-input>
            </div>
          </el-form-item>
          <el-form-item class="EditNewFormItem" prop="status">
            <div class="EditNewFormItemName"><span class="signSpan">* </span>状态</div>
            <div class="EditNewFormItemIpt">
              <el-select v-model="Row.status" placeholder="请选择是否显示" >
                <el-option v-for="(item, key) in StatusList" :key="key" :label="item" :value="key"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item class="EditNewFormBtns">
            <div class="EditNewFormItemName">图片线索（选填）:</div>
            <div class="EditNewFormItemIpt">
              <div class="Picture">
                <el-upload
                  ref="upload-avatar"
                  list-type="picture-card"
                  :action="upload"
                  :headers="heads"
                  :limit="1"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :on-exceed="handleExceed"
                  :on-preview="handlePreview">
                  <i class="el-icon-plus"></i>
                  <div class="elsff">上传图片</div>
                </el-upload>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="EditNewFormBtns">
            <div class="FormBtns">
              <div class="FormBtnsQuery" v-if="addPanel == true" @click="BtnAdd()">创建</div>
              <div class="FormBtnsQuery" v-if="editPanel == true" @click="BtnEdit()">保存</div>
              <div class="FormBtnsClose" @click="Close()">取消</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>




  </div>
</template>

<script>
import axios from 'axios' 
export default {
  name: "index",
  data() {
    return {
      upload: 'https://rest-api.duxin365.com/admin/ajax/upload',
      heads: {token: ''},
      TypeList: {
        online: "在线客服",
        phone: "电话客服"
      },
      StatusList: [
        "隐藏",
        "显示"
      ],
      //搜索参数
      search: {
        type: "",
        username: "",
        phone: "",
        service: "",
        status: "",
        keyword: "",
      },
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      total: 0,
      Row: {
        type: "",
        username: "",
        avatar: "",
        service: "",
        phone: "",
        weixin: "",
        tag: "",
        star: 5,
        status: 1,
        weigh: 0,
      },
      Rows: {
        type: "",
        username: "",
        avatar: "",
        service: "",
        phone: "",
        weixin: "",
        tag: "",
        star: 5,
        status: 1,
        weigh: 0,
      },
      rules:{
        type:[{required: true, message: '请输入', trigger: 'change'}],
        username:[{required: true, message: '请输入', trigger: 'blur'}],
        service:[{required: true, message: '请输入', trigger: 'blur'}],
        phone:[{required: true, message: '请输入', trigger: 'blur'}],
        weixin:[{required: true, message: '请输入', trigger: 'blur'}],
        tag:[{required: true, message: '请输入', trigger: 'blur'}],
        star:[{required: true, message: '请输入', trigger: 'blur'}],
        status:[{required: true, message: '请输入', trigger: 'change'}],
        weigh:[{required: true, message: '请输入', trigger: 'blur'}],
      },
      fileList:[],
      addPanel: false,
      editPanel: false,
      titleMath:'',
      editId: 0,
    }
  },
  mounted() {
    var that = this
    let token = window.localStorage.getItem("accessToken")
    that.heads.token = token
    that.loadTable();
  },
  methods: {
    loadTable() {
      var that = this
      axios({
        method: 'post',
        url: '/admin/member/kefu/index',
        data: {
          page: that.page.currentPage,
          limit: that.page.pageSize,
          filter: that.search,
        },
      }).then(function (res) {
        that.tableData = res.data.data.rows
        that.total = res.data.data.total
        that.$forceUpdate()
      })
    },

    BtnSearch(e) {
      var that = this
      that.page.currentPage = 1;
      if (e == false) {
        that.search = {
          type: "",
          username: "",
          phone: "",
          servcice: "",
          status: "",
          keyword: "",
        };
      }
      that.loadTable();
    },
    BtnAdd() {
      var that = this
      that.$refs['ruleFormRef'].validate((valid) =>{
        if (valid) {
          axios({
            method: 'post',
            url: '/admin/member/kefu/add',
            data: {
              row: that.Row
            },
          }).then(function (res) {
            if (res.data.code == 0) {
              that.$message.warning(res.data.msg);
            } else {
              that.$message.success(res.data.msg);
              that.addPanel = false
              that.loadTable();
            }
          })
        }
      })
    },
    BtnEdit() {
      var that = this
       that.$refs['ruleFormRef'].validate((valid) =>{
        if(valid){
          axios({
            method: 'put',
            url: '/admin/member/kefu/edit',
            data: {
              id: that.editId,
              row: that.Row
            },
          }).then(function (res) {
            if (res.data.code == 0) {
              that.$message.warning(res.data.msg);
            } else {
              that.$message.success(res.data.msg);
              that.editPanel = false
              that.loadTable();
            }
          })
        }
      })
    },
    showAdd() {
      var that = this
      that.addPanel = true;
      that.titleMath = '添加'
      that.Row = {
        type: "",
        username: "",
        avatar: "",
        service: "",
        phone: "",
        weixin: "",
        tag: "",
        star:'',
        status:'',
        weigh: '',
      };
      that.fileList = [];
    },
    HandleEdit(e, data) {
      var that = this
      that.editPanel = true;
      that.titleMath = '编辑'
      that.editId = data.kefu_id
      axios.get('/admin/member/kefu/read', {   // 详情
        params: {
          id: data.kefu_id
        }
      }).then(function (res) {
        console.log(res.data.data);
        if (res.data.code == 0) {
          alert('请求失败');
        } else {
          that.Row = {
            type: res.data.data.row.type,
            username: res.data.data.row.username,
            avatar: res.data.data.row.avatar,
            service: res.data.data.row.service,
            phone: res.data.data.row.phone,
            weixin: res.data.data.row.weixin,
            tag: res.data.data.row.tag,
            star: res.data.data.row.star,
            status: res.data.data.row.status,
            weigh: res.data.data.row.weigh,
          }
          //图片
          let fileArr = [];
          let fileObj = {};
          fileObj.name = "file";
          fileObj.url = res.data.data.row.full_avatar;
          fileArr.push(fileObj);
          that.fileList = fileArr
        }
      })
    },
    Close() {
      var that = this
      that.addPanel = false;
      that.editPanel = false;
    },
    HandleDel(e, data) {
      var that = this
      var arr = []
      //主键ID
      arr.push(data.kefu_id)
      that.$confirm("确定要删除吗？", "提示", {
        type: "primary"
      }).then(() => {
        axios({
          method: 'delete',
          url: '/admin/member/kefu/del',
          data: {
            ids: arr
          }
        }).then(function (res) {
          if (res.data.code == 0) {
            that.$message.warning(res.data.msg);
          } else {
            that.$message.success(res.data.msg);
            that.loadTable();
          }
        })
      })
    },
    DelMore() {
      var that = this
      var arr = that.multipleSelection_id
      if (that.multipleSelection_id == null) {      //批量删除
        that.$message.warning('请勾选信息');
      } else {
        that.$confirm("确定要删除吗？", "提示", {
          type: "primary"
        }).then(() => {
          axios({
            method: 'delete',
            url: '/admin/member/kefu/del',
            data: {
              ids: arr
            }
          }).then(function (res) {
            if (res.data.code == 0) {
              that.$message.warning(res.data.msg);
            } else {
              that.$message.success(res.data.msg);
              that.loadTable();
            }
          })
        })
      }
    },
    //图片上传成功
    handleSuccess(e) {
      console.log(e);
      var that = this
      that.Row.avatar = e.data.url
    },
    handleExceed  (files)  {
      this.$refs["upload-avatar"].clearFiles()
      this.$refs["upload-avatar"].handleStart(files[0])
      this.$refs["upload-avatar"].submit();
    },
    handlePreview(file) {
      window.open(file.url);
    },
    //开关
    handleChange(e) {
      console.log(e)
    },
    //勾选
    handleSelect(e) {
      var that = this
      console.log(e);
      var arr = []
      var acc = []
      if (e.length == 0) {
        that.multipleSelection_id = null
      } else {
        for (let i = 0; i < e.length; i++) {
          const element = e[i];
          //主键ID
          arr.push(element.kefu_id)
          acc.push(element)
        }
        that.multipleSelection_id = arr
      }
      that.multipleSelection = acc
    },
    handleCurrentChange(page) {
      var that = this
      that.page.currentPage = page;
      that.loadTable();
    },
    formatDate(value) {    // 时间戳
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      const time = y + "-" + MM + "-" + d
    },
  }
}
</script>
